import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=4f8552da&scoped=true&"
import script from "./AppLoading.vue?vue&type=script&lang=ts&"
export * from "./AppLoading.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=4f8552da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8552da",
  null
  
)

export default component.exports